import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { fontSize } from "../../styles";
import {
  updateCheckList,
  deleteCheckList,
  addChecklist,
} from "../../redux/dispatchers";
import useWindowDimensions from "./window-dimensions";
import { store } from "../../redux/store";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "90%",
    border: "none",
    display: "flex",
    marginTop: 10,
    marginLeft: 20,
    marginBottom: 10,
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      marginLeft: 15,
    },
  },
  text: {
    fontWeight: "bold",
    color: "white",
    flexGrow: 1,
  },
  form: {
    display: "flex",
    alignItems: "center",
    marginBottom: 10,
  },
  numbering: {
    fontSize: fontSize.h4,
    marginLeft: 10,
    marginRight: 20,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  dotlabel: {
    fontSize: fontSize.h1,
    marginLeft: 10,
    marginRight: 20,
    color: "#7F7F7F",
    display: "inline-block",
    verticalAlign: "middle",
  },
  add: {
    cursor: "pointer",
    width: 150,
    marginTop: 2,
    marginLeft: 4,
    marginRight: 12,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginBottom: 10,
    },
  },
  addLabel: {
    marginLeft: 8,
  },
  remove: {
    padding: "5px 10px",
    fontSize: fontSize.h5,
    marginLeft: 8,
    marginBottom: 15,
    background: "#7B0000",
    textTransform: "none",
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
    },
  },
  subtitle: {
    marginTop: 10,
    marginLeft: 30,
    textTransform: "unset !important",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 15,
    },
  },
  title: {
    marginTop: 10,
    marginLeft: 20,
    [theme.breakpoints.down("xs")]: {
      fontSize: fontSize.h4,
      marginLeft: 15,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: fontSize.h5,
      marginLeft: 15,
    },
  },
  two: {
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "70vh",
    },
  },
  smallerTwo: {
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "70vh",
    },
  },
  none: {},
  one: {
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "60vh",
    },
  },
}));

export const InputChecklist = (props) => {
  const { title, type, details, two, one, smallerTwo } = props;
  const { height } = useWindowDimensions();
  // get contents from the game state by type
  const contents = useSelector((state) => state.gameStates[type]);

  const classes = useStyles();
  const farthest = store.getState().gameStates.status;
  const onView = store.getState().gameStates.onViewStatus;
  const { page } = useSelector((state) => state.gameStates);
  const viewOtherPage = !(
    onView === farthest ||
    (page === "/diagnosis" && farthest === 7) ||
    (page === "/management" && farthest === 12)
  );

  const updateChecklistHandler = (event) => {
    const { id } = event.currentTarget;
    const item = event.target.value;
    // modify the checklist value
    updateCheckList(type, id, type, item, null);
  };

  // display list of textfield
  const display = () => {
    return (
      <>
        {!!two ? (
          <Typography variant="h2" className={classes.title}>
            {title}
          </Typography>
        ) : (
          <Typography variant="h3" className={classes.subtitle}>
            {title}
          </Typography>
        )}
        <div className={classes.container}>
          <div
            className={
              two
                ? classes.two
                : one
                ? classes.one
                : smallerTwo
                ? classes.smallerTwo
                : classes.none
            }
            style={{
              maxHeight: two
                ? height - 320
                : one
                ? height - 320
                : smallerTwo
                ? height - 360
                : "none",
            }}
          >
            <>
              {contents.length > 0 ? (
                contents.map((content) => (
                  <form
                    className={classes.form}
                    key={content.id}
                    noValidate
                    autoComplete="off"
                  >
                    <label className={classes.dotlabel}>•</label>
                    <TextField
                      className={classes.text}
                      id={content.id}
                      placeholder={details}
                      multiline
                      size="small"
                      value={content.item}
                      variant="outlined"
                      InputProps={{
                        disableLabel: true,
                        disableUnderline: true,
                      }}
                      onChange={updateChecklistHandler}
                      disabled={viewOtherPage}
                    />
                    <IconButton
                      style={{
                        display:
                          viewOtherPage || type === "provisional"
                            ? "none"
                            : "block",
                      }}
                      aria-label="delete"
                      onClick={() => deleteCheckList(type, content.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </form>
                ))
              ) : (
                <div>No Answer</div>
              )}
            </>
          </div>
          {!viewOtherPage && type !== "provisional" ? (
            <div
              className={classes.add}
              onClick={() => {
                addChecklist(type, type, "", null);
              }}
            >
              <AddCircleOutlineIcon />
              <Typography className={classes.addLabel} variant="h4">
                Add
              </Typography>
            </div>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  };
  return display();
};
